//DBTables
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { ModuleStatuses, ModuleTypeFamily, ModuleTypeId } from "../../types/DBTables";
import { useState } from "react";
import { logAndNotifyError, logDebugSilently } from "../../modules/logger";
import { deleteHttp, post } from "../../modules/server";
import notify from "devextreme/ui/notify";
import BuildingWizard from "../../pages/BuildingWizard";
import { useGlobalData } from "../GlobalDataProvider";
import Configuration from "../../pages/Configuration";
import BuildingRoundList from "../Round/BuildingRoundList";
import { Card, Table } from "react-bootstrap";

import BuildingImage from "../../Assets/building.svg";
import { json } from "stream/consumers";
import { nameof } from "../Global/Utils";
import { IModuleByggnadsdata } from "../../types/ModuleDatas";
import { DTOBuilding, DTOModule } from "../../types/building";
import { UserInfo } from "../../types/user-info";
import { Height } from "devextreme-react/chart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faBuilding, faCopy, faInfo, faInfoCircle, faRemove, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Font } from "devextreme-react/bar-gauge";
import { Colors } from "../../modules/Colors";
import StickyBreadCrumb, { BreadCrumbItem } from "../Global/StickyBreadCrumb";
// import { UserInfo } from "os";

enum BuildingStatus {
  ConfigurationMissing = 1,
  Warning = 2,
  Error = 3,
}
interface BuildingDetailInfo {
  byggnadStatus: BuildingStatus;
  address: string;
  byggArea: string;
  område: string;
  moduleCountTexts: string[];
  moduleConfiguredTexts: string[];
  moduleCounts: number[];
  moduleConfiguredCounts: number[];
  allModulesConfigured: boolean;
}

const excludedModuleTypes = [ModuleTypeId.KylaAnnatSystem, ModuleTypeId.KylaSaknas, ModuleTypeId.VarmePrimarAnnatSystem, ModuleTypeId.VarmePrimarSaknas, ModuleTypeId.VarmeSekundarSaknas];

const BuildingDetails = () => {
  const [deleteBuildingConfirmation, setDeleteBuildingConfirmation] = useState(false);

  //
  const { buildingId } = useParams();
  const navigate = useNavigate();

  const globalData = useGlobalData();
  const user = globalData.user;
  const building = buildingId ? globalData.buildings?.find((b) => b.id === parseInt(buildingId)) : undefined; // as DTOBuilding;  buildingsHandler.getBuilding(parseInt(buildingId)) : undefined;

  if (building === undefined || user === undefined) {
    return <></>;
  }

  const getFamilyTitel = (family: ModuleTypeFamily) => {
    switch (family) {
      case ModuleTypeFamily.Basdata:
        return "Basdata";
      case ModuleTypeFamily.VärmePrimar:
        return "Primärvärmesystem";
      case ModuleTypeFamily.VärmeSekundar:
        return "Sekundärvärmesystem";
      case ModuleTypeFamily.VärmeEl:
        return "Värmesystem el";
      case ModuleTypeFamily.Kyla:
        return "Kyla";
      case ModuleTypeFamily.Ventilation:
        return "Ventilation";
      default:
        return "?";
    }
  };

  const buildingInfo = getBuildingInfo(building);
  function getBuildingInfo(building: DTOBuilding): BuildingDetailInfo {
    let moduleCountTexts = [] as string[];
    let moduleConfiguredTexts = [] as string[];
    let moduleCounts = [] as number[];
    let moduleConfiguredCounts = [] as number[];
    let moduleNotConfigured = [] as DTOModule[];
    let status = BuildingStatus.Error;
    let allModulesConfigured = false;

    let actualModules = building.modules.filter((m) => !excludedModuleTypes.includes(m.moduleTypeId));

    const allFamilies = actualModules.reduce((acc, cur) => {
      let f = globalData.moduleTypes.find((mt) => mt.id === cur.moduleTypeId)?.family;
      if (f) {
        if (!acc.find((existing) => existing === f)) acc.push(f);
      }
      return acc;
    }, [] as ModuleTypeFamily[]);

    for (var i = 0; i < allFamilies.length; i++) {
      const family = allFamilies[i];

      const title = getFamilyTitel(family);
      const modulesAll =
        family !== ModuleTypeFamily.Basdata
          ? building.modules.filter((m) => globalData.moduleTypes.find((mt) => mt.id === m.moduleTypeId)?.family === family)
          : building.modules.filter((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
      const modules = modulesAll.filter((m) => !excludedModuleTypes.includes(m.moduleTypeId));

      const moduleCount = modules.length;
      const moduleConfiguredCount = modules.filter((m) => m.status === ModuleStatuses.Configured).length;

      moduleCountTexts.push(title); // + ": " + moduleNotConfigureCount + "/" + moduleCount);
      moduleConfiguredTexts.push("Konfigurerade moduler: " + moduleConfiguredCount + "/" + moduleCount);
      moduleCounts.push(moduleCount);
      moduleConfiguredCounts.push(moduleConfiguredCount);

      if (moduleCount > moduleConfiguredCount) {
        moduleNotConfigured.push(...modules.filter((m) => m.status !== ModuleStatuses.Configured));
      }
    }

    if (moduleNotConfigured.length > 0) {
      status = BuildingStatus.ConfigurationMissing;
    } else {
      allModulesConfigured = true;
    }
    const moduleBuildingData = building.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
    const dataBuildingData = moduleBuildingData ? JSON.parse(moduleBuildingData.data) : {};
    const mFamil = globalData.moduleTypes;

    return {
      byggnadStatus: status,
      address: "Adress: " + dataBuildingData[nameof<IModuleByggnadsdata>("adress")],
      byggArea: "Byggnadsarea: " + dataBuildingData[nameof<IModuleByggnadsdata>("byggnadArea")],
      område: "Område: " + dataBuildingData[nameof<IModuleByggnadsdata>("område")],
      moduleCountTexts: moduleCountTexts,
      moduleConfiguredTexts: moduleConfiguredTexts,
      moduleCounts: moduleCounts,
      moduleConfiguredCounts: moduleConfiguredCounts,
      allModulesConfigured,
    } as BuildingDetailInfo;
  }

  async function deleteBuildingFromDB() {
    logDebugSilently("Delete building " + new Date());
    try {
      const config = await deleteHttp("DeleteBuilding/" + buildingId);
      if (config.succeed) {
        PubSub.publish("RefreshBuildings");
        navigate("/Buildings");
      } else {
        setDeleteBuildingConfirmation(false);
        notify("Kunde inte ta bort byggnad!");
      }
    } catch (ex) {
      logAndNotifyError(ex);
    }
  }

  const onGoToEditBuilding = () => {
    navigate("Edit/1");
  };

  const onGoToConfigure = () => {
    navigate("Configuration");
  };

  const onGoToRound = () => {
    //navigate("Round");  //todo! Strukturerad route!

    const includedModules = building?.modules.filter((m) => !excludedModuleTypes.includes(m.moduleTypeId));
    const allModulesConfigured = !includedModules.find((m) => m.status !== ModuleStatuses.Configured);
    if (allModulesConfigured) navigate("/round/building/" + buildingId);
    else notify("Alla moduler måste vara konfigurerade innan rondering kan inledas!", "warning");

    ///round/building/3
  };

  const onDeleteBuildingClickFirst = () => {
    if (deleteBuildingConfirmation) {
      deleteBuildingFromDB();
    } else setDeleteBuildingConfirmation(true);
  };

  const onCancelDeleteClick = () => {
    setDeleteBuildingConfirmation(false);
  };

  const onCopyBuilding = async () => {
    const result = await post("CopyBuilding/" + buildingId, {});
    if (result.succeeded) {
      notify("Byggnaden kopierades, du hittar kopian när du går tillbaka till listan med byggnader!", "success");
      PubSub.publish("RefreshBuildings");
    } else notify("Byggnaden kunde inte kopieras", "error");
  };

  const onCopyBuildingInklRounds = async () => {
    const result = await post("CopyBuilding/" + buildingId, { copyRounds: true });
    if (result.succeeded) {
      notify("Byggnaden kopierades, du hittar kopian när du går tillbaka till listan med byggnader!", "success");
      PubSub.publish("RefreshBuildings");
    } else notify("Byggnaden kunde inte kopieras", "error");
  };
  //

  const breadcrumbItems: BreadCrumbItem[] = [];

  breadcrumbItems.push({ text: "Byggnader", navTo: "/Buildings/" });
  breadcrumbItems.push({ text: building.name, navTo: "/Buildings/" + buildingId, active: true });

  return (
    <Routes>
      <Route element={<BuildingWizard />} path="/Edit/*" />
      <Route element={<Configuration />} path="/Configuration/:family?/:moduleId?" />
      {/* <Route element={<BuildingWizard />} path="/Round/*" /> */}
      <Route
        element={
          building ? (
            <>
              <StickyBreadCrumb items={breadcrumbItems} className="mb-2" />
              <div className="row g-3">
                <div className="col-lg-4">
                  <BuildingCard building={building} buildingInfo={buildingInfo} user={user} />
                </div>
                <div className="col-lg-8">
                  <ConfigCard building={building} buildingInfo={buildingInfo} user={user} />
                </div>
                <div className="col-12">
                  <Card>
                    <Card.Header>
                      <span className="d-inline-flex align-items-center">
                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" role="button" onClick={() => PubSub.publish("ShowHelp", "help_Ronderingar")} />
                        Ronderingar
                      </span>
                      <div className="headerGroup">
                        {/* <div className="col-4 d-flex align-items-center">
                          <Card.Title className="m-0 fs-4"></Card.Title>
                        </div> */}
                        {user.roles.Round && (
                          <>
                            <button style={{ width: 200 }} type="button" className={"btn btn-success"} onClick={onGoToRound}>
                              Skapa rondering
                            </button>
                          </>
                        )}

                        {/* <div className="col-8 d-flex justify-content-end pe-3">
                        </div> */}
                      </div>
                    </Card.Header>
                    {user?.roles.Round && <BuildingRoundList buildingId={building.id} user={user} />}
                  </Card>
                </div>
              </div>
            </>
          ) : (
            <></>
          )
        }
        path="*"
      />
    </Routes>
  );
};

interface IPropsConfigCard {
  building: DTOBuilding;
  buildingInfo: BuildingDetailInfo;
  user: UserInfo;
}
const ConfigCard = ({ building, buildingInfo, user }: IPropsConfigCard) => {
  const navigate = useNavigate();
  const onGoToConfigure = () => {
    navigate("Configuration");
  };

  return (
    <Card className="h-100">
      <Card.Header>
        <span className="d-inline-flex align-items-center">
          <FontAwesomeIcon icon={faInfoCircle} className="me-2" role="button" onClick={() => PubSub.publish("ShowHelp", "help_Configuration")} />
          Konfigurering
        </span>
        {user.roles.Configuration && (
          <>
            <div className="headerGroup">
              {!buildingInfo.allModulesConfigured && <FontAwesomeIcon shake={true} icon={faArrowRight} className="me-2" style={{ marginTop: "auto", marginBottom: "auto" }} />}

              <button style={{ width: 200 }} type="button" className={"btn btn-success "} onClick={onGoToConfigure}>
                Konfigurera moduler
              </button>
            </div>
          </>
        )}
      </Card.Header>
      <Table className="m-0 p-0" striped bordered hover>
        <thead>
          <tr>
            <th>Moduler</th>
            <th>Antal system</th>
            <th>Antal konfigurerade</th>
          </tr>
        </thead>
        <tbody>
          {buildingInfo.moduleCountTexts.map((t, i) => (
            <tr key={i}>
              <td>{buildingInfo.moduleCountTexts[i]}</td>
              <td>{buildingInfo.moduleCounts[i]}</td>
              <td style={{ backgroundColor: buildingInfo.moduleCounts[i] !== buildingInfo.moduleConfiguredCounts[i] ? Colors.RedLight : "" }}>{buildingInfo.moduleConfiguredCounts[i]}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      {/* <Card.Body className="mb-0"></Card.Body> */}
    </Card>
  );
};

interface IPropsBuildingCard {
  building: DTOBuilding;
  buildingInfo: BuildingDetailInfo;
  user: UserInfo;
}
const BuildingCard = ({ building, buildingInfo, user }: IPropsBuildingCard) => {
  const [deleteBuildingConfirmation, setDeleteBuildingConfirmation] = useState(false);
  const [copying, setCopying] = useState(false);
  const [copyingWithRounds, setCopyingWithRounds] = useState(false);
  const [isDeleteing, setIsDeleteing] = useState(false);
  const navigate = useNavigate();

  async function deleteBuildingFromDB() {
    logDebugSilently("Delete building " + new Date());
    try {
      const config = await deleteHttp("DeleteBuilding/" + building.id);
      if (config.succeed) {
        PubSub.publish("RefreshBuildings");
        navigate("/Buildings");
      } else {
        setDeleteBuildingConfirmation(false);
        notify("Kunde inte ta bort byggnad!");
      }
    } catch (ex) {
      logAndNotifyError(ex);
    }
  }

  const onDeleteBuildingClickFirst = async () => {
    if (deleteBuildingConfirmation) {
      setDeleteBuildingConfirmation(false);
      setIsDeleteing(true);
      await deleteBuildingFromDB();
      setIsDeleteing(false);
    } else setDeleteBuildingConfirmation(true);
  };

  const onCancelDeleteClick = () => {
    setDeleteBuildingConfirmation(false);
  };
  const onGoToEditBuilding = () => {
    navigate("Edit/1");
  };

  const onCopyBuilding = async () => {
    try {
      setCopying(true);
      const dt = new Date().toLocaleDateString("sv-SE");
      const tm = new Date().toLocaleTimeString("sv-SE", { hour12: false });
      const newName = building.name + " - Kopia " + dt + " " + tm;
      const result = await post("CopyBuilding/" + building.id, { newName });
      if (result.succeeded) {
        notify("Byggnaden kopierades, du hittar kopian när du går tillbaka till listan med byggnader!", "success");
        PubSub.publish("RefreshBuildings");
      } else notify("Byggnaden kunde inte kopieras - " + result.message, "error");
    } catch (ex: any) {
      logAndNotifyError("Byggnaden kunde inte kopieras! (" + ex.toString() + ")");
    } finally {
      setCopying(false);
    }
  };

  const onCopyBuildingInklRounds = async () => {
    try {
      const dt = new Date().toLocaleDateString("sv-SE");
      const tm = new Date().toLocaleTimeString("sv-SE", { hour12: false });
      const newName = building.name + " - Kopia " + dt + " " + tm;
      setCopyingWithRounds(true);
      const result = await post("CopyBuilding/" + building.id, { copyRounds: true, newName });
      if (result.succeeded) {
        notify("Byggnaden kopierades, du hittar kopian när du går tillbaka till listan med byggnader!", "success");
        PubSub.publish("RefreshBuildings");
      } else notify("Byggnaden kunde inte kopieras", "error");
    } catch (ex: any) {
      logAndNotifyError("Byggnaden kunde inte kopieras! (" + ex.toString() + ")");
    } finally {
      setCopyingWithRounds(false);
    }
  };

  return (
    <Card className="h-100">
      <Card.Header>
        <span className="d-inline-flex align-items-center">
          <FontAwesomeIcon icon={faInfoCircle} className="me-2" role="button" onClick={() => PubSub.publish("ShowHelp", "help_BuildingInfo")} />
          Byggnadsinformation
        </span>
      </Card.Header>
      <Card.Body className="mb-2">
        {/* <Card.Img variant="top" src={BuildingImage} alt={building.name} height="60px" width="60px" /> */}
        <Card.Title>{"Byggnadsnamn: " + building?.name}</Card.Title>
        <Card.Text className="">{buildingInfo.område}</Card.Text>
        <Card.Text className="mb-0">{buildingInfo.address}</Card.Text>
        <Card.Text className="mb-0">{buildingInfo.byggArea}</Card.Text>
      </Card.Body>
      <Card.Body className="mb-0">
        <div className="row gy-1 ps-3 pe-3">
          {user.roles.Buildings && (
            <>
              <Card.Title className="text-center">{"Byggnadsfunktioner"}</Card.Title>
              <div className="col-12">
                <button type="button" className={"btn btn-success w-100 m-0"} onClick={onGoToEditBuilding}>
                  <FontAwesomeIcon icon={faBuilding} className="me-2" />
                  Anläggningar
                </button>
              </div>
              <div className="col-12">
                <button type="button" className={"btn btn-secondary w-100"} onClick={onCopyBuilding} disabled={copying}>
                  <FontAwesomeIcon icon={copying ? faSpinner : faCopy} spin={copying} className="me-2" />
                  Kopiera
                </button>
              </div>
              <div className="col-12">
                {!deleteBuildingConfirmation ? (
                  <button type="button" className={"btn btn-danger w-100"} onClick={onDeleteBuildingClickFirst} disabled={isDeleteing}>
                    <FontAwesomeIcon icon={isDeleteing ? faSpinner : faRemove} spin={isDeleteing} className="me-2" />
                    Ta bort byggnad
                  </button>
                ) : (
                  <div className="d-grid gap-2 d-flex justify-content-end">
                    Är du säker?
                    <button type="button" className={"btn btn-danger "} onClick={onDeleteBuildingClickFirst}>
                      Ta bort
                    </button>
                    <button type="button" className={"btn btn-secondary "} onClick={onCancelDeleteClick}>
                      Avbryt
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
          {/* {user.roles.Admin && (
            <>
              <div className="col-12">
                <button type="button" className={"btn btn-secondary w-100"} onClick={onCopyBuildingInklRounds} disabled={copyingWithRounds}>
                  <FontAwesomeIcon icon={copyingWithRounds ? faSpinner : faCopy} spin={copyingWithRounds} className="me-2" />
                  Kopiera (inkl rounds)
                </button>
              </div>
            </>
          )} */}
        </div>
      </Card.Body>
    </Card>
  );
};

export default BuildingDetails;
